import React, { useEffect } from "react";
import Input, { type IInputProps } from "components/form/input/Input";
import {
  EMAIL_BUILDER_SETTINGS_DEFER_AUTOSAVE_ATTR,
  notifyEmailBuilderSettingsTextInputBlurred,
  notifyEmailBuilderSettingsTextInputFocused,
} from "../emailBuilderSettingsTextAutosaveDeferral";

export function EmailBuilderSettingsTextInput(props: IInputProps) {
  const { onFocus, onBlur, ...rest } = props;

  useEffect(() => {
    return () => {
      notifyEmailBuilderSettingsTextInputBlurred();
    };
  }, []);

  return (
    <div {...{ [EMAIL_BUILDER_SETTINGS_DEFER_AUTOSAVE_ATTR]: "" }}>
      <Input
        {...rest}
        onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
          notifyEmailBuilderSettingsTextInputFocused();
          onFocus?.(event);
        }}
        onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
          onBlur?.(event);
          notifyEmailBuilderSettingsTextInputBlurred();
        }}
      />
    </div>
  );
}
